import { supabase, unwrap } from '@/services/supabase/client'
import type { AppNotification } from '@/features/notifications/avisos'

/** Tus avisos, del más nuevo al más viejo, con quién lo hizo. (§0080) */
export async function listNotifications(): Promise<AppNotification[]> {
  return (unwrap(await supabase.rpc('list_notifications', { p_limit: 60 })) ?? []) as AppNotification[]
}

/** El numerito de la campanita. */
export async function unreadNotificationsCount(): Promise<number> {
  return (unwrap(await supabase.rpc('unread_notifications_count')) ?? 0) as number
}

/** Abrir la lista los da todos por leídos. */
export async function markNotificationsRead(): Promise<number> {
  return (unwrap(await supabase.rpc('mark_notifications_read', { p_ids: null })) ?? 0) as number
}
